<template>
  <div class="home">
    <!-- <div class="home-main">
      <img alt="logo" src="../../assets/logo.png">
      <div>
        慧充管理平台
      </div>
    </div> -->
    <el-row :gutter="10">
      <el-col :xs="xs" :sm="12">
        <div class="home_left">
          <router-link
            v-for="(item, index) in cardList"
            :key="index"
            :to="{ path: item.path }"
            class="home_card"
            :style="{
              background: item.bgc,
            }"
          >
            <div class="card_num">
              <number-card-wrapper :num="cardObj[item.key]" />
            </div>
            <div class="card_title">{{ item.title }}</div>
            <Icon class="card_icon" :icon="item.icon" />
            <Icon class="card_icon_dit" icon="icon-ditutubiao-bianpo" />
          </router-link>
        </div>
      </el-col>
      <el-col :xs="xs" :sm="12">
        <div class="home_right">
          <div class="home_card_title">
            <Icon class="title_line" icon="icon-tubiaozhizuo-" />统计条目
          </div>
          <div class="home_table">
            <el-table
              :data="tableData"
              :header-cell-style="{ color: '#608cf4' }"
              highlight-current-row
            >
              <el-table-column
                align="center"
                label="序号"
                type="index"
                width="100"
              >
              </el-table-column>
              <el-table-column align="center" property="name" label="名称">
              </el-table-column>
              <el-table-column align="center" property="value" label="数值">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { clientLogin } from "@/api/login/clientLogin";
import getHomePageInfo from "@/api/user/agent-manage/getHomePageInfo";
import NumberCardWrapper from "@/components/number-card-wrapper";
import createdMixin from "@/mixin/createMixin";
import numberFilters from "@/mixin/numberFilters";

export default {
  name: "Home",
  mixins: [createdMixin, numberFilters],
  components: {
    NumberCardWrapper,
  },
  data: () => {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.body.clientHeight,
      clentMax: undefined,
      xs: { span: 24, offset: 0 },
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6,
      tableData: [],
      data: {
        allChargeNum: 0,
        money: 0,
        onTheDayOfTheProfit: 0,
        todayChargeNum: 0,
        socketNum: 0,
        cardNum: 0,
        userNum: 0,
        accruedBalance: 0,
      },
      cardObj: {
        cellNumber: 0,
        cardNum: 0,
        deviceTotal: 0,
        carportNum: 0,
        socketNum: 0,
        accessControlNum: 0,
        chargeFailureEquipment: 0,
        accessFailureEquipment: 0,
      },
      cardList: [
        {
          title: "小区总数",
          key: "cellNumber",
          icon: "icon-xiaoqu-xianxing",
          path: "/PowerStationManage/CellManagement",
          bgc: "#29c19b",
        },
        {
          title: "电卡总数",
          key: "cardNum",
          icon: "icon-zhiqia",
          path: "/ElectricityCardManage",
          bgc: "#29c19b",
        },
        {
          title: "设备总数",
          key: "deviceTotal",
          icon: "icon-shebei",
          path: "/PowerStationManage/MyPowerStation",
          bgc: "#82b8ff",
        },
        {
          title: "车库数量",
          key: "carportNum",
          icon: "icon-kucunzaishoucheliang",
          path: "/GarageManage/GarageManage",
          bgc: "#f4b646",
        },
        {
          title: "端口总数",
          key: "socketNum",
          icon: "icon-chazuo",
          path: "",
          bgc: "#82b8ff",
        },
        {
          title: "门禁数量",
          key: "accessControlNum",
          icon: "icon-menjin",
          path: "/GarageManage/AccessControlDevice",
          bgc: "#f4b646",
        },
        {
          title: "充电故障",
          key: "chargeFailureEquipment",
          icon: "icon-xialingyingicon-34",
          path: "",
          bgc: "#fb8f8c",
        },
        {
          title: "门禁故障",
          key: "accessFailureEquipment",
          icon: "icon-guzhangliebiao",
          path: "",
          bgc: "#fb8f8c",
        },
      ],
    };
  },
  created() {
    // 如果路由参数携带code，则表示来自微信授权页面，进行登录，并缓存微信token信息
    if (this.$route.query.code) {
      clientLogin(this.$route.query.code).then((res) => {
        localStorage.setItem("wechat_client_token_self", res.access_token);
      });
    }
  },
  mounted() {
    let max =
      this.clientWidth > this.clientHeight
        ? this.clientWidth
        : this.clientHeight;
    if (max / 2 > this.clientWidth || max / 2 > this.clientHeight) {
      max = max / 2;
    }
    this.clentMax = max;

    let card = document.getElementsByClassName("card");
    for (let i = 0; i < card.length; i++) {
      let ele = card[i];
      ele.style.setProperty("font-size", this.clentMax * 0.019 + "px");
    }
  },
  methods: {
    fetchData() {
      getHomePageInfo().then((res) => {
        const data = res.data;
        this.tableData.push({
          name: "账户余额(元)",
          value: `¥ ${data.money}`,
        });
        this.tableData.push({
          name: data.hasMCH ? "微信实际营收(元)" : "实际营收(元)",
          value: `¥ ${(data.hasMCH
            ? data.weChatTotalPay
            : data.accruedBalance
          ).toFixed(2)}`,
        });
        this.tableData.push({
          name: "今日收益(元)",
          value: `¥ ${data.onTheDayOfTheProfit}`,
        });
        this.tableData.push({
          name: "总营收(元)",
          value: `¥ ${(data.accruedBalance + data.token).toFixed(2)}`,
        });
        this.tableData.push({
          name: "代币收益(元)",
          value: `¥ ${data.token}`,
        });
        this.tableData.push({
          name: "今日充电时长",
          value: `${data.todayChargeNum}`,
        });
        this.tableData.push({
          name: "累计充电时长",
          value: `${data.allChargeNum}`,
        });
        // this.tableData.push({
        //   name: "端口总数",
        //   value: `${data.socketNum}`,
        // });
        this.cardObj.socketNum = data.socketNum;
        // this.tableData.push({
        //   name: "电卡总数",
        //   value: `${data.cardNum}`,
        // });
        this.cardObj.cardNum = data.cardNum;
        this.tableData.push({
          name: "用户总数",
          value: `${data.userNum}`,
        });

        // this.tableData.push({
        //   name: "车库数量",
        //   value: `${data.carportNum}`,
        // });
        this.cardObj.carportNum = data.carportNum;
        this.tableData.push({
          name: "车辆数量",
          value: `${data.carNum}`,
        });

        this.cardObj.cellNumber = data.cellNumber;
        this.cardObj.deviceTotal = data.deviceTotal;
        this.cardObj.accessControlNum = data.accessControlNum;
        this.cardObj.chargeFailureEquipment = data.chargeFailureEquipment;
        this.cardObj.accessFailureEquipment = data.accessFailureEquipment;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  .home_left {
    flex: 7;
    height: calc(100vh - 70px);
    background: #fff;
    box-sizing: border-box;
    padding: 15px;
    display: flex;
    flex-wrap: wrap;

    .home_card {
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 40px 30px;
      position: relative;
      color: #fff;
      margin: 0 8px 15px;
      width: calc(50% - 16px);
      height: calc(25% - 15px);

      .card_num {
        font-size: 35px;
        margin-bottom: 15px;
      }

      .card_title {
        letter-spacing: 1px;
      }

      .card_icon {
        position: absolute;
        bottom: 15%;
        right: 2%;
        font-size: 80px;
        opacity: 0.2;
      }

      .card_icon_dit {
        position: absolute;
        bottom: -20px;
        left: -10px;
        font-size: 80px;
        opacity: 0.2;
      }

      &:hover {
        opacity: 0.9;
      }
    }
  }
  .home_right {
    flex: 3;
    background: #fff;
    padding: 8px 20px 35px;
    height: calc(100vh - 70px);
    overflow: auto;
    &::-webkit-scrollbar {
      // display: none;
    }
  }
  .home_card_title {
    color: #608cf4;
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .title_line {
      font-weight: bold;
      margin-right: 7px;
    }
  }
}
.home-card {
  //border: 1px red solid;
  display: block;
  position: relative;
  text-align: center;
  margin-bottom: 3vh;

  .card {
    //border: 1px red solid;
    position: relative;
    text-align: center;

    .text {
      //font-size: 1vw;
      margin-top: -28%;
      margin-left: 30%;

      .text2 {
        color: #fb6604;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .home {
    .home_left {
      height: auto;
      margin-bottom: 10px;
      .home_card {
        padding: 30px;
        .card_num {
          font-size: 28px;
        }
        .card_icon {
          display: none;
        }
        .card_icon_dit {
          opacity: 0.15;
        }
      }
    }

    .home_right {
      height: auto;
    }
  }
}
</style>
